import { Instance, SnapshotOut, types } from 'mobx-state-tree'
import { ModalProps } from 'react-native'

import { GameSnapshotModel } from '../api-store'
import { withRootStore } from '../extensions'

export const GameSheetKinds = {
  observers: 'observers',
  leaveGame: 'leaveGame',
  leaveCommunityGame: 'leaveCommunityGame',
  terminateGame: 'terminateGame',
  deleteAccount: 'deleteAccount',
  deleteInvite: 'deleteInvite',
  deleteSchedule: 'deleteSchedule',
  showCards: 'showCards',
  leaveFirstGame: 'leaveFirstGame'
} as const
export type GameSheetKind = keyof typeof GameSheetKinds

export type FromScreen = 'game' | 'profile' | 'invite' | 'schedule'

export const GameSheet = types.model('GameSheet').props({
  game: types.maybe(GameSnapshotModel),
  props: types.frozen<ModalProps>(),
  kind: types.enumeration<GameSheetKind>('GameSheetKind', Object.values(GameSheetKinds)),
  isBlocking: types.optional(types.boolean, false),
  timeToKeepOpen: types.optional(types.number, 0),
  message: types.optional(types.string, ''),
  triggeredFromScreen: types.optional(types.string, 'game')
})

export type GameSheetType = Instance<typeof GameSheet>

export const GameSheetQueue = types
  .model('GameSheetQueue')
  .props({
    sheetQueue: types.optional(types.array(GameSheet), [])
  })
  .extend(withRootStore)
  .views((self) => ({
    getFirstGameSheet(): GameSheetType | undefined {
      if (self.sheetQueue.length > 0) {
        return self.sheetQueue[0]
      }
      return undefined
    }
  }))
  .actions((self) => ({
    pushGameSheets(data: GameSheetType) {
      return self.sheetQueue.push(GameSheet.create(data))
    },
    shiftGameSheets() {
      return self.sheetQueue.shift()
    },
    clearGameSheetQueue() {
      self.sheetQueue.clear()
    },
    createObserversSheet() {
      self.sheetQueue.push(
        GameSheet.create({
          props: {},
          kind: GameSheetKinds.observers,
          isBlocking: false,
          timeToKeepOpen: 0
        })
      )
    },
    createLeaveGameSheet(isCommunityGame = false) {
      self.sheetQueue.push(
        GameSheet.create({
          props: {},
          kind: isCommunityGame ? GameSheetKinds.leaveCommunityGame : GameSheetKinds.leaveGame,
          isBlocking: false,
          timeToKeepOpen: 0
        })
      )
    },
    createLeaveFirstGameSheet() {
      self.sheetQueue.push(
        GameSheet.create({
          props: {},
          kind: GameSheetKinds.leaveFirstGame,
          isBlocking: false,
          timeToKeepOpen: 0
        })
      )
    },
    // createDeleteAccountSheet() {
    //   self.sheetQueue.push(
    //     GameSheet.create({
    //       props: {},
    //       kind: GameSheetKinds.deleteAccount,
    //       isBlocking: false,
    //       timeToKeepOpen: 0,
    //       triggeredFromScreen: 'profile'
    //     })
    //   )
    // },
    createDeleteInviteSheet() {
      self.sheetQueue.push(
        GameSheet.create({
          props: {},
          kind: GameSheetKinds.deleteInvite,
          isBlocking: false,
          timeToKeepOpen: 0,
          triggeredFromScreen: 'invite'
        })
      )
    },
    createShowCardsSheet(timeToKeepOpen = 0) {
      self.sheetQueue.push(
        GameSheet.create({
          props: {},
          kind: GameSheetKinds.showCards,
          isBlocking: false,
          timeToKeepOpen: timeToKeepOpen
        })
      )
    },
    createDeleteScheduleSheet() {
      self.sheetQueue.push(
        GameSheet.create({
          props: {},
          kind: GameSheetKinds.deleteSchedule,
          isBlocking: false,
          timeToKeepOpen: 0,
          triggeredFromScreen: 'schedule'
        })
      )
    },
    createTerminateGameSheet() {
      self.sheetQueue.push(
        GameSheet.create({
          props: {},
          kind: GameSheetKinds.terminateGame,
          isBlocking: false,
          timeToKeepOpen: 0
        })
      )
    }
  }))

/**
 * The GameSheetQueueStore instance.
 */
export type GameSheetQueueStore = Instance<typeof GameSheetQueue>

/**
 * The data of a GameSheetQueueStore.
 */
export type GameSheetQueueStoreSnapshot = SnapshotOut<typeof GameSheetQueue>
